module.exports = __webpack_public_path__ + "static/img/user2.1036c4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user2.png
// module id = cJe7
// module chunks = 1